<template>
  <section>
    <social-header v-if="currentEnv" title="城市列表"></social-header>
    <div class="city-list">
      <p class="city-list-col" :class="{selected: isSelected(item)}" v-for="item in provinceList" :key="item.provinceId" v-stat:click="{name:'choose'}">
        <a v-if="item.isMunicipality" href="javascript:;" @click="changeUserCityThenGoActivityHomePage(item)">{{item.provinceName}}<em class="iconfont_M" :class="{'icon-select_M': isSelected(item)}"></em></a>
        <a v-else href="javascript:;" @click="goCityPage(item)">{{item.provinceName}}<em class="iconfont_M icon-more_M"></em></a>
      </p>
    </div>
    <social-dialog title="正在加载" category="tips" v-bind:show="isLoading"></social-dialog>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

export default {
  components: {
    SocialHeader,
    SocialDialog
  },
  name: 'Province',
  data: function () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      provinceList: 'provinceList',
      userCity: 'userCity'
    }),
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    }
  },
  created: function () {
    this.isLoading = true
    changeDocumentTitle('城市列表')
    let that = this
    this.$store.dispatch('getProvinceList').then(() => {
      that.isLoading = false
    })
  },
  methods: {
    isSelected: function (province) {
      let userCity = this.$store.getters.userCity
      return province.isMunicipality && province.city.cityId == userCity.cityId
    },
    hasMoreCity: function (province) {
      return !province.isMunicipality
    },
    changeUserCityThenGoActivityHomePage: function (province) {
      let city = {
        cityId: province.city.cityId,
        cityName: province.city.cityName
      }
      this.$store.dispatch('changeUserCity', {city})
      this.$router.go(-1)
    },
    goCityPage: function (province) {
      this.$router.push('/city?provinceId=' + province.provinceId)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/activity/province.vue